export const TOKEN_KEY = "maxManagement";
export const PROFILE_USERTYPE = "management";
